import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { BoldBodyText } from '../styles/Text'
import { Divider, FlexColumn, PrimaryColorDivider, WhiteBGContainer } from '../styles/Containers'
import DetailSection from '../common/DetailSection.js'

const SectionContainer = styled(WhiteBGContainer)`
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px;
`

const EmphasizedSectionContainer = styled(SectionContainer)`
  background: ${theme.colors.primaryExtraLight};
  border: 1px solid ${theme.colors.primary};
`

function renderDetails(section, details, emphasize = false) {
  const keysWithSubchildren = Object.keys(details).filter(d => typeof details[d] === 'object')
  const detailsWithoutSubchildren = Object.keys(details).reduce((acc, d) => {
    if (typeof details[d] !== 'object') acc[d] = details[d]
    return acc
  }, {})

  const Container = emphasize ? EmphasizedSectionContainer : SectionContainer
  const DividerComponent = emphasize ? PrimaryColorDivider : Divider

  return (
    <Container>
      <BoldBodyText>{section}</BoldBodyText>
      <DividerComponent />
      {Object.keys(detailsWithoutSubchildren).length > 0 && <DetailSection details={detailsWithoutSubchildren} useWhiteFileBg={emphasize} />}
      {Object.keys(keysWithSubchildren).length > 0 &&
        keysWithSubchildren.map(d => (
          <DetailSection key={d} sectionLabel={d !== 'thirdPartyFiles' ? d : undefined} details={details[d]} useWhiteFileBg={emphasize} />
        ))}
    </Container>
  )
}

function FOIRequest({ foiRequest, order = 'default' }) {
  return (
    <FlexColumn gap="15px">
      {order === 'requestFirst' ? (
        <>
          {renderDetails('Request Details', foiRequest.requestDetails, true)}
          {renderDetails('Type of Information', foiRequest.typeOfInformation)}
          {renderDetails('Your Contact Information', foiRequest.contactInformation)}
          {renderDetails('Document Access', foiRequest.documentAccess)}
        </>
      ) : (
        <>
          {renderDetails('Your Contact Information', foiRequest.contactInformation)}
          {renderDetails('Type of Information', foiRequest.typeOfInformation)}
          {renderDetails('Request Details', foiRequest.requestDetails)}
          {renderDetails('Document Access', foiRequest.documentAccess)}
        </>
      )}
    </FlexColumn>
  )
}

FOIRequest.propTypes = {
  foiRequest: PropTypes.shape({
    contactInformation: PropTypes.shape({
      'Access for Business': PropTypes.string,
      Name: PropTypes.string,
      Phone: PropTypes.string
    }).isRequired,
    typeOfInformation: PropTypes.shape({
      'Type of Information': PropTypes.string
    }).isRequired,
    requestDetails: PropTypes.shape({
      'Time Period Start': PropTypes.string,
      'Time Period End': PropTypes.string,
      Request: PropTypes.string
    }).isRequired,
    documentAccess: PropTypes.shape({
      accessMethod: PropTypes.string
    }).isRequired
  }).isRequired,
  order: PropTypes.oneOf(['default', 'requestFirst'])
}
export default FOIRequest
